import React, { useMemo } from 'react';
import styled, {css} from 'styled-components';
import SbEditable from 'components/SbEditableExtended';

import ContentWrapper from 'components/contentWrapper';
import Card from 'components/blocks/blockPartials/card';

import theme, {bp} from 'settings/theme';

import calculateBottomSpacingClass from 'components/blocks/utils/calculateBottomSpacingClass';



// Component
const Component = (props) => {

  const spacingBottomClass = useMemo(() => calculateBottomSpacingClass(props.block?.bottom_spacing), [props.block?.bottom_spacing]);

  if(!props.block){
    return(<div>Storyblok block missing</div>);
  }

	return(
    <SbEditable content={props.block}>
      <StyledComponent className={`blockCard ${spacingBottomClass}`}>

        <ContentWrapper fullWidthAt={[1,2]}>

          <div className="blockCard-wrapper">
          
            <Card
              mainImageUrl={props.block.main_image}
              title={props.block.title}
              subtitle={props.block.subtitle}
              text={props.block.text}
              link={props.block.link}
              linkText={props.block.link_text}
              displaySettings={props.block.display_settings}
            />

          </div>

        </ContentWrapper>

      </StyledComponent>
    </SbEditable>
	)

}


export default Component;


// Styles
const StyledComponent = styled.div`

  @media (min-width: ${bp(3)}) {

    .blockCard-wrapper{
      max-width: 350px;
      margin-left: auto;
      margin-right: auto;
    }

  }


`;